import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Concept, ConceptType } from '../../models/Concept';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { UIAnimations } from '../../UIAnimations';

@Component({
    selector: 'lib-render-analysis-results',
    imports: [NgbTooltip, CommonModule],
    templateUrl: './render-analysis-results.component.html',
	standalone: true,
    styleUrl: './render-analysis-results.component.scss',
    animations: UIAnimations
})
export class RenderAnalysisResultsComponent {
	@Input() concepts: Concept[] | null = [];
	@Output() selectedConcepts = new EventEmitter<Concept[]>();
	
	private _selectedConcepts: Concept[] = [];
	
	protected readonly conceptType = ConceptType;
	
	constructor() {
		
	}
	
	
	
	public ToggleConceptSelect(selectedConcept: Concept): void {
		if (this._selectedConcepts.includes(selectedConcept)) {
			// If the concept is already selected, remove it from the list of selected concepts
			this._selectedConcepts = this._selectedConcepts.filter((concept) => concept !== selectedConcept);
			this.selectedConcepts.emit(this._selectedConcepts);
		} else {
			this._selectedConcepts.push(selectedConcept);
			this.selectedConcepts.emit(this._selectedConcepts);
		}
	}
	
	public IsConceptSelected(selectedConcept: Concept): boolean {
		return this._selectedConcepts.includes(selectedConcept);
	}
	
	public HasConceptsOfType(type: ConceptType, mentioned: boolean): boolean {
		if (this.concepts) {
			return this.concepts.some((concept) => concept.conceptType === type && concept.mentioned == mentioned);	
		} else {
			return false;
		}
		
	}
}
